module.exports = __webpack_public_path__ + "band_3.17d8757e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_3.png
// module id = HSwS
// module chunks = 0